import {createReducer} from '../../../utilities';
import {
  REQUEST_FETCH_STATS_TOURNAMENTS_AVERAGE_SIZES,
  SUCCESS_FETCH_STATS_TOURNAMENTS_AVERAGE_SIZES,
  FAIL_FETCH_STATS_TOURNAMENTS_AVERAGE_SIZES,
} from '../../../../actions/entities/statistics/tournaments';

const initialState = {
  data: null,
  error: false,
  isFetching: false,
};

function requestFetch(state) {
  return {
    ...state,
    isFetching: true,
  };
}

function successFetch(state, action) {
  const {data} = action;
  return {
    ...state,
    data,
    isFetching: false,
  };
}

function failFetch(state, action) {
  const {error} = action;
  return {
    ...state,
    isFetching: false,
    error,
  };
}

export default createReducer(initialState, {
  [REQUEST_FETCH_STATS_TOURNAMENTS_AVERAGE_SIZES]: requestFetch,
  [SUCCESS_FETCH_STATS_TOURNAMENTS_AVERAGE_SIZES]: successFetch,
  [FAIL_FETCH_STATS_TOURNAMENTS_AVERAGE_SIZES]: failFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/statistics/tournaments/averageSizes.js